import { Button } from "@blueprintjs/core";
import { generateSchema } from "decorator-form";
import React from "react";
import { default as Rsjf } from "react-jsonschema-form";

import Class from "core/util/Class";

/**
 * basic wrapper around react-jsonschema-form and decorator-form
 */

interface IAutoFormProps<T> {
	clazz: Class<T>;
	onChange: (data: T) => void;
	value: T;
	submitButton?: JSX.Element;
	excludeFields?: string[];
}

export default function AutoForm<T = any>(props: IAutoFormProps<T>) {
	return (
		<Rsjf
			{...generateSchema(props.clazz, undefined, props.excludeFields)}
			formData={props.value}
			onChange={!!props.submitButton ? undefined : (f) => props.onChange(f.formData)}
			onSubmit={!!props.submitButton ? (f) => props.onChange(f.formData) : undefined}
		>
			{props.submitButton || <div />}
		</Rsjf>
	);
}



// WEBPACK FOOTER //
// ./src/core/components/AutoForm.tsx